import { jsxs, jsx } from 'react/jsx-runtime';
import { sitemapLinks, keyLinks, partnerLinks } from './data.js';
import styles from './Footer.module.scss.js';
import { Sitemap } from './components/Sitemap.js';
import KeyLinks from './components/KeyLinks.js';
import Partners from './components/Partners.js';
import ResponsibleGaming from './components/ResponsibleGaming.js';

const defaultRgComponent = /* @__PURE__ */ jsxs("p", { children: [
  "If you or someone you know has a gambling problem and wants help, call",
  " ",
  /* @__PURE__ */ jsx("strong", { children: "1-800-Gambler" }),
  " or visit",
  " ",
  /* @__PURE__ */ jsx("strong", { children: /* @__PURE__ */ jsx(
    "a",
    {
      href: "https://www.fanduel.com/RG",
      target: "_blank",
      rel: "noopener noreferrer",
      "data-test-id": "footer-rg-link",
      children: "FanDuel.com/RG"
    }
  ) }),
  "."
] });
const Footer = ({
  testId = "ogFeLibraryFooterComponent",
  footerSitemapLinks = sitemapLinks,
  keyLinks: keyLinks$1 = keyLinks,
  partnerLinks: partnerLinks$1 = partnerLinks,
  rgComponent = defaultRgComponent,
  footerSitemapClass,
  isHeadingUppercase = true
}) => {
  return /* @__PURE__ */ jsxs("footer", { className: styles.footer, role: "contentinfo", "data-test-id": testId, children: [
    /* @__PURE__ */ jsxs("div", { className: styles.footerContent, children: [
      /* @__PURE__ */ jsx(
        Sitemap,
        {
          footerSitemapLinks,
          footerSitemapClass,
          isHeadingUppercase
        }
      ),
      /* @__PURE__ */ jsx(KeyLinks, { keyLinks: keyLinks$1 }),
      /* @__PURE__ */ jsx(ResponsibleGaming, { rgComponent })
    ] }),
    /* @__PURE__ */ jsx(Partners, { partnerLinks: partnerLinks$1 })
  ] });
};

export { Footer as default };
//# sourceMappingURL=Footer.js.map
